import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganismoService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getOrganismo(): Observable<any> {
    return this.http.get(this.baseUrl + 'parOrganismos', { headers: this.header(this.token) });
  }

  getListaOrganismosXTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listaOrganismosXTechoId/' + id, { headers: this.header(this.token) });
  }

  getOrganismoVigentes(): Observable<any> {
    return this.http.get(this.baseUrl + 'parOrganismosVigentes', { headers: this.header(this.token) });
  }

  getOrganismoById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parOrganismo/' + id, { headers: this.header(this.token) });
  }

  postOrganismo(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);    
    return this.http.post(this.baseUrl + 'parOrganismo', bodyString, { headers: this.header(this.token) });
  }

  putOrganismo(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parOrganismo', bodyString, { headers: this.header(this.token) });
  }

  deleteOrganismo(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parOrganismo/' + id, { headers: this.header(this.token) });
  }
}
